import React from 'react';
import PropTypes from 'prop-types';

import Container from '@Theme/hijunior/components/Container/Container';
import Row from '@Theme/hijunior/components/Row/Row';
import Text from '@Theme/hijunior/components/Text/Text';
import Icon from '@Theme/hijunior/components/Icon/Icon';

import * as styles from './News.module.scss';
import ArticleTile from '../../components/ArticleTile/ArticleTile';

const propTypes = {
  /**
   * Module heading
   */
  heading: PropTypes.string,

  /**
   * Module description
   */
  description: PropTypes.string,

  /**
   * icon name
   */
  icon: PropTypes.string,

  /**
   * Array of item properties
   */
  items: PropTypes.arrayOf(
    PropTypes.shape({
      picture: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string
      }),
      heading: PropTypes.string,
      date: PropTypes.string,
      url: PropTypes.string,
      comments: PropTypes.string
    })
  ),

  /**
   * boolean if true section has dark mode
   */
  isDark: PropTypes.bool,

  /**
   * boolean if true section has smaller paddings anf no margin top
   */
  isSmall: PropTypes.bool
};

/**
 * Latest News Module
 */
const News = ({
  description,
  heading,
  items,
  icon,
  isSmall,
  isDark
}) => (
  <section className={`${styles.root} ${isDark ? styles.rootDark : ''} ${isSmall ? styles.rootSmall : ''}`}>
    <Container>
      {!isDark && <Icon classname={styles.rootIcon} name={icon}/>}
      <Text as='h2' contents={heading} classname={styles.rootHeading}/>
      <Text contents={description} classname={styles.rootDescription}/>
      <Row classname={styles.rootRow}>
        {items?.map((data, index) => <ArticleTile {...data} key={index}/>)}
      </Row>
    </Container>
  </section>
);

News.propTypes = propTypes;

export default News;
